<template>
  <div v-if="show" class="modal-overlay">
    <div class="dropdown-values-modal">
      <button class="close-button" @click="handleClose">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4.16504 4.16602L15.8309 15.8319" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4.1642 15.8319L15.8301 4.16602" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div class="modal-content">
        <div class="modal-content-inner">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M9 12L11 14L15 10" stroke="#7AC4EB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#7AC4EB" stroke-width="2" />
          </svg>
        </div>
        <h2 class="modal-title">{{ $t('extractionFields.modals.dropdown_values.title') }}</h2>
        <p class="modal-message">{{ $t('extractionFields.modals.dropdown_values.message', { fieldName: fieldName }) }}</p>

        <div class="dropdown-values-list">
          <div v-for="(value, index) in dropdownValues" :key="index" class="dropdown-value-item">
            <span class="value-number">{{ index + 1 }}.</span>
            <span class="value-text">{{ value }}</span>
          </div>
        </div>

        <div class="modal-buttons">
          <button class="close-modal-button" @click="handleClose">{{ $t('close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownValuesModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    fieldName: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dropdown-values-modal {
  display: flex;
  width: 500px;
  max-height: 600px;
  padding: 24px 24px 23px 40px;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff;
  position: relative;
  overflow-y: auto;
}

.close-button {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 14px;
  top: 14px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.modal-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.modal-content-inner {
  display: flex;
  width: 80px;
  height: 80px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f0f9fd;
  margin-bottom: 16px;
}

.modal-title {
  color: var(--primary-color);
  text-align: center;
  font-family: Lato, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 8px;
  margin-top: 0;
}

.modal-message {
  overflow: hidden;
  color: #667085;
  text-overflow: ellipsis;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  text-align: center;
  margin-bottom: 24px;
}

.dropdown-values-list {
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  margin-bottom: 24px;
}

.dropdown-value-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font-family: Lato, sans-serif;
}

.dropdown-value-item:last-child {
  border-bottom: none;
}

.value-number {
  color: var(--primary-color);
  font-weight: 600;
  margin-right: 12px;
  min-width: 24px;
}

.value-text {
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  word-break: break-word;
}

.modal-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.close-modal-button {
  width: 120px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: Lato, sans-serif;
  font-weight: 500;
  background: var(--primary-color);
  border: none;
  color: white;
}

.close-modal-button:hover {
  background: #0056b3;
}
</style>
